import { getBasicListInitialState, getBasicListReducerSlice } from '@probatix/common/utils/service'

import { PayloadAction } from '@reduxjs/toolkit'

import { STATE_KEY } from '../geoLocationService.constants'

export const slice = getBasicListReducerSlice<any>(
  getBasicListInitialState(), STATE_KEY, {
    setGeoLocations: (list: any, action: PayloadAction<any>) => {
      list.data = action.payload
      list.fetching = false
      list.errors = null
    },
  })

export default slice.reducer
